<!-- NOTE: This was designed specifically to be used full width in its own row, 
but with the field width restricted here manually. It works in the Wizard/Meeting Create,
but if this component will be used elsewhere it may cause responsive issues -->
<wizard-labeled-field label="Meeting Type" [size]="fieldSize" [isInline]="true">
    <wizard-tooltip>
        Meeting types enable you to pre-configure your meeting settings, and then reuse those settings for faster
        meeting scheduling.
        <a href="/settings/meeting/new" target="_blank">Add Meeting Type</a> or
        <a
            href="https://faq.calendarhero.com/hc/en-us/articles/4430389795355-What-can-my-assistant-understand-"
            target="_blank"
            >Learn More</a
        >
    </wizard-tooltip>
    <div class="ui selection dropdown" id="type">
        <input type="hidden" name="type" value="default" />
        <i class="dropdown icon"></i>
        <div class="default text">Meeting Type</div>
    </div>

    <div *ngIf="availabilityTypeText" class="ui circular large label fit-content">
        {{ availabilityTypeText }}
    </div>
</wizard-labeled-field>

<div class="warning" *ngIf="showWarning">
    <i class="exclamation triangle icon"></i>When using a Microsoft Calendar for a Group Class, all attendees will be
    notified when new people register. To avoid this, use a Google Calendar for this Meeting Type.
</div>
